module.exports = __webpack_public_path__ + "img/leftSilde.66e4cb99.png";